class TestimonialSlide extends HTMLElement {
  constructor() {
    super();
    this.Slide = this.querySelector('.js-testimonial-slide');
    this.swiperMenuImageSlide = new Swiper(this.Slide, {
      loop: true,
      navigation: {
        nextEl: ".testimonial-button--next",
        prevEl: ".testimonial-button--prev",
      },
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 15
    });
  }
}
customElements.define("testimonial-slide", TestimonialSlide);

class MenuImageSlide extends HTMLElement {
  constructor() {
    super();
    this.Slide = this.querySelector('.js-related-product-slide');
    this.swiperMenuImageSlide = new Swiper(this.Slide, {
      loop: true,
      navigation: {
        nextEl: ".menu-image-button--next",
        prevEl: ".menu-image-button--prev",
      },
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 15,
      breakpoints: {
        990: {
          slidesPerView: 2,
          spaceBetween: 40
        }
      }
    });
  }
}
customElements.define("menu-image-slide", MenuImageSlide);


document.addEventListener('DOMContentLoaded', function () {
  const imageCards = document.querySelectorAll('.mega-image-card');

  imageCards.forEach((card) => {
    card.addEventListener('click', function () {
      const targetPopupId = card.getAttribute('data-target');
      const targetPopup = document.querySelector(targetPopupId);
      const overlay = targetPopup.querySelector('.overlay');

      if (targetPopup) {
        targetPopup.style.display = 'block';
        overlay.style.display = 'block'; // Hiển thị overlay
        document.querySelector('body').style.overflowY = 'hidden';
      }
    });
  });

  const closeButtons = document.querySelectorAll('.close-btn');
  closeButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const popup = button.closest('.popup-menu');
      const overlay = popup.querySelector('.overlay');

      popup.style.display = 'none';
      overlay.style.display = 'none'; // Ẩn overlay khi đóng popup
      document.querySelector('body').style.overflowY = 'auto';
    });
  });

  // Đóng popup khi click vào overlay
  const overlays = document.querySelectorAll('.overlay');
  overlays.forEach((overlay) => {
    overlay.addEventListener('click', function () {
      const popup = overlay.closest('.popup-menu');
      popup.style.display = 'none';
      overlay.style.display = 'none'; // Ẩn overlay khi click ra ngoài
      document.querySelector('body').style.overflowY = 'auto';
    });
  });
});